const SidebarTutorialIcon = ({ isOpen }) => {
  const size = isOpen ? 21 : 25;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      stroke="currentColor"
      strokeWidth="5.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20 20h-10a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h40a2 2 0 0 0 2-2V32" />
      <polygon points="26 28 26 44 42 36 26 28" />
      <path d="M32 12 56 12 44 22 32 12z" />
      <path d="M44 22 41 36" />
    </svg>
  );
};

export default SidebarTutorialIcon;
